module.exports = __webpack_public_path__ + "static/peanuts-95b59a97b6ede9fb3fffb196b25d59be.gif";